class StickyAtcButton extends HTMLElement {
  constructor() {
    super()
    this.buyBox = document.querySelector('.c-product-purchase')
  }

  connectedCallback() {
    const that = this

    window.addEventListener('scroll', () => {
      if(that.buyBox.getBoundingClientRect().bottom < 0) {
        that.classList.add('visible')
      } else {
        that.classList.remove('visible')
      }
    });

    this.addEventListener('click', this.scrollToBuyBox.bind(this))
  }

  scrollToBuyBox(event) {
    this.buyBox.scrollIntoView({ behavior: "smooth", block: "end" });
  }
}

if (!customElements.get('sticky-atc-button')) customElements.define('sticky-atc-button', StickyAtcButton)
